module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"参加する一覧":"参加する一覧","学ぶ一覧":"学ぶ一覧","コンテンツ":"コンテンツ","コンテンツタグ一覧":"コンテンツタグ一覧"},"en":{"参加する一覧":"Events","学ぶ一覧":"Library","コンテンツ":"Article","コンテンツタグ一覧":"Article Tags"}}')
  delete Component.options._Ctor
}
